import { render, staticRenderFns } from "./ListShopContents.vue?vue&type=template&id=6c4f1bfa&scoped=true"
import script from "./ListShopContents.vue?vue&type=script&lang=ts"
export * from "./ListShopContents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4f1bfa",
  null
  
)

export default component.exports